import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCloseBtn = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={13} fill="none" {...props}>
    <path
      fill="#ABABAB"
      d="M.252.644a.857.857 0 0 1 1.213 0L6 5.18 10.535.644a.858.858 0 0 1 1.214 1.213L7.212 6.392l4.537 4.535a.857.857 0 0 1-.935 1.4.858.858 0 0 1-.279-.187L6 7.604 1.465 12.14a.857.857 0 1 1-1.213-1.213l4.536-4.535L.252 1.857a.857.857 0 0 1 0-1.213Z"
    />
  </svg>
);
export default SvgCloseBtn;
